export const freePackage = {
  application: {
    icon: 'https://flowaccountcdn.com/My_company/FlowAccount.png',
    name: 'FlowAccount',
  },
  level: 0,
  seminarDescriptionEN: 'Free! Seminar basic course for 1 person',
  descriptionEN: '',
  isRecommend: false,
  isActive: true,
  isFreePackage: true,
  feature: {
    items_1: [
      '1 user',
      'Standard document templates',
      '<span class="text-layout">Unlimited</span> document creation',
      'Manage <span class="text-layout">unlimited</span> products and contacts',
      'Support multiple currencies',
      'Sales and output tax reports',
      'Business overview dashboard',
      'iOS and Android mobile application<br><a  href="https://itunes.apple.com/th/app/new-flowaccount/id1454207520" rel="nofollow noopener" target="_blank" aria-label="Donwload IOS"> <img  class="app-store logo-mobile-margin " src="https://flowaccountcdn.com/new_landing/icon/App_Store_v3.png" width="auto" height="21" alt="appStore logo"/></a> <a href="https://play.google.com/store/apps/details?id=com.flowaccount.android&hl=th"rel="nofollow noopener"target="_blank"aria-label="Donwload Android">   <img class="play-store logo-mobile-margin " src="https://flowaccountcdn.com/new_landing/icon/Play_Store_v3.png" width="auto" height="21" alt="android logo" loading="lazy"/></a> <a href="https://appgallery.huawei.com/app/C105848487"rel="nofollow noopener"target="_blank"aria-label="Donwload huawei app gallery">   <img class="play-store logo-mobile-margin " src="https://flowaccountcdn.com/new_landing/icon/huawei-logo-v2.png" width="auto" height="21" alt="huawei logo" loading="lazy"/></a>',
    ],
  },
  description: 'Premium Package',
  price: 0,
  internalName: 'New_GL_Premium_NoAutokey',
  nameTH: 'ฟรี',
  nameEN: 'Free',
  id: 99,

  configuration: {
    Name: '',
    Price: '0',
    PeriodType: '3',
    Quantity: '1',
    Days: '365',
    IsPremiumPackage: true,
    MaxUsers: 1,
    Modules: [1, 3, 5, 25],
    IsPackagePromotion: false,
    Storage: 0,
  },
  packageId: 91,
  featureTH: {
    items_1: [
      '1 สิทธิ์ผู้ใช้งาน',
      'รูปแบบเอกสารมาตรฐาน',
      'สร้างเอกสารได้ <span class="text-layout">ไม่จำกัด</span>',
      'จำนวนสินค้าและผู้ติดต่อ <span class="text-layout">ไม่จำกัด</span>',
      'รองรับสกุลเงินต่างประเทศ',
      'รายงานสรุปยอดขายและภาษี',
      'แดชบอร์ดสรุปการเงินของธุรกิจ',
      'ใช้งานผ่านแอปพลิเคชั่นมือถือ<br><a  href="https://itunes.apple.com/th/app/new-flowaccount/id1454207520" rel="nofollow noopener" target="_blank" aria-label="Donwload IOS"> <img  class="app-store logo-mobile-margin" src="https://flowaccountcdn.com/new_landing/icon/App_Store_v3.png" width="auto" height="21" alt="appStore logo"/></a> <a href="https://play.google.com/store/apps/details?id=com.flowaccount.android&hl=th"rel="nofollow noopener"target="_blank"aria-label="Donwload Android">   <img class="play-store logo-mobile-margin" src="https://flowaccountcdn.com/new_landing/icon/Play_Store_v3.png" width="auto" height="21" alt="android logo" loading="lazy"/></a> <a href="https://appgallery.huawei.com/app/C105848487"rel="nofollow noopener"target="_blank"aria-label="Donwload huawei app gallery">   <img class="play-store logo-mobile-margin " src="https://flowaccountcdn.com/new_landing/icon/huawei-logo-v2.png" width="auto" height="21" alt="huawei logo" loading="lazy"/></a>',
    ],
  },
}
